function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.667A17.3 17.3 0 0 0 11.333 16l2.444-2.444a.885.885 0 0 1 1.111-.222 11.622 11.622 0 0 0 4 .667A1.113 1.113 0 0 1 20 15.111v3.778A1.2 1.2 0 0 1 18.889 20 18.873 18.873 0 0 1 0 1.111 1.2 1.2 0 0 1 1.111 0H5a1.113 1.113 0 0 1 1.111 1.111 12.583 12.583 0 0 0 .667 4 1.368 1.368 0 0 1-.222 1.111ZM19.111.778 18.333 0l-7.222 7V2.222H10v6.667h6.667V7.778h-4.556Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgCall;